<ion-content [scrollEvents]="true" (ionScroll)="onScroll($event)">
  <ion-grid class="box-container" style="padding-top: var(--header-height);">
    <ion-row class="bradcrumb-single">
      <ion-col size="auto">
        <ion-row>
          <ion-col class="each-roat" (click)="redirectToCatalog(i)"  *ngFor="let item of productData?.data?.tree;let i=index" size="auto" ><h2>{{item.title}} <img src="../../../assets/icon/row-right.svg" *ngIf="i<productData?.data?.tree.length-1"/></h2></ion-col>
        </ion-row>
      </ion-col>
    </ion-row>
    <ion-row class="product-section">
      <ion-col sizeXl="5" sizeMd="5" sizeSm="12" sizeXs="12" class="image-gallery">
        <ion-row>
          <ion-col>
            <swiper *ngIf="!productData" class="features-image" [config]="configSkeleton" [lazy]="true">
              <ng-container>
                <ng-template swiperSlide>
                  <ion-skeleton-text style="height: 100%;width: 100%;"></ion-skeleton-text>
                </ng-template>
              </ng-container>
            </swiper>
            <swiper *ngIf="productData && config" class="features-image" [config]="config" [lazy]="true" (activeIndexChange)="activeIndexChange()">
              <ng-container *ngFor="let item of productData?.data?.files">
                <ng-template swiperSlide>
                  <img src="{{item.url}}" alt="" loading="lazy">
                </ng-template>
              </ng-container>
            </swiper>
            <swiper *ngIf="productData" class="thumb-gallery" #thumb_swiper [config]="configVertical" (init)="thumbInit($event)">
              <ng-container *ngFor="let item of productData?.data?.files">
                <ng-template swiperSlide>
                  <img src="{{item.thumb_url}}" alt="" loading="lazy">
                </ng-template>
              </ng-container>

              <div (click)="thumbPrev()" class="swiper-button-prev"></div>
              <div (click)="thumbNext()" class="swiper-button-next"></div>
            </swiper>
            <swiper *ngIf="configVertical && !productData" class="thumb-gallery" [config]="configVertical">
              <ng-container *ngFor="let item of [1,2,3,4,5,6]">
                <ng-template swiperSlide>
                  <ion-skeleton-text [animated]="true" style="width: 100%;height: 100%"></ion-skeleton-text>
                </ng-template>
              </ng-container>
            </swiper>
          </ion-col>
        </ion-row>
        <!-- <ion-row class="rating-pd">
          <ion-col>
            <div class="rating-box">
              <h5>Your rate for this product:</h5>
              <img src="../../../assets/img/rate.png"/>
              <span class="rate-score"><small>4</small>/<small>5</small></span>
            </div>
          </ion-col>
        </ion-row> -->
      </ion-col>
      <ion-col sizeXl="7" sizeMd="7" sizeSm="12" sizeXs="12" class="product-info">
        <ion-row *ngIf="!appInitData" class="join-button">
          <ion-col>
            <ion-button (click)="registerTrader()">Join our Trade Program to view prices</ion-button>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col class="product-title">
            <h1>{{productData?.data?.title}}</h1>
            <ion-skeleton-text *ngIf="!productData?.data?.title" [animated]="true" style="width: 80%;height: 37px"></ion-skeleton-text>
          </ion-col>
        </ion-row>
        <ion-row *ngIf="productData?.data?.description">
          <ion-col class="product-description">
            <p>{{productData?.data?.description}}</p>
            <ion-skeleton-text *ngIf="!productData?.data?.description" [animated]="true" style="width: 80%;height: 12px"></ion-skeleton-text>
            <ion-skeleton-text *ngIf="!productData?.data?.description" [animated]="true" style="width: 80%;height: 12px"></ion-skeleton-text>
            <ion-skeleton-text *ngIf="!productData?.data?.description" [animated]="true" style="width: 80%;height: 12px"></ion-skeleton-text>
            <ion-skeleton-text *ngIf="!productData?.data?.description" [animated]="true" style="width: 80%;height: 12px"></ion-skeleton-text>
            <ion-skeleton-text *ngIf="!productData?.data?.description" [animated]="true" style="width: 60%;height: 12px"></ion-skeleton-text>
            <ion-skeleton-text *ngIf="!productData?.data?.description" [animated]="true" style="width: 50%;height: 12px"></ion-skeleton-text>
          </ion-col>
        </ion-row>
        <ng-container *ngIf="!fields">
          <ion-row *ngFor="let item of [1,2,3,4]" style="margin-top: 15px;">
            <ion-col size="4">
              <ion-skeleton-text [animated]="true" style="width: 100%;height: 30px"></ion-skeleton-text>
            </ion-col>
            <ion-col size="8"></ion-col>
            <ion-col size="3">
              <ion-skeleton-text [animated]="true" style="width: 90%;height: 30px"></ion-skeleton-text>
            </ion-col>
            <ion-col size="3">
              <ion-skeleton-text [animated]="true" style="width: 90%;height: 30px"></ion-skeleton-text>
            </ion-col>
            <ion-col size="3">
              <ion-skeleton-text [animated]="true" style="width: 90%;height: 30px"></ion-skeleton-text>
            </ion-col>
          </ion-row>
        </ng-container>

        <ion-row class="bool-item-row">
          <ng-container *ngFor="let item of selectedProductToShowDetail?.items">
            <ion-col size="auto" class="each-boolian-item" *ngIf=" item.field==='Appliance Pull' || item.field==='Quick Ship' || item.field==='Water Resistant' ">
              <span>{{item.field}}:</span> <b>{{item.item_value}}</b>
            </ion-col>
          </ng-container>
        </ion-row>
        <ng-container *ngFor="let item of fields">
          <ion-row class="each-pd-field" *ngIf="item.field!=='SKU' && item.field!=='Appliance Pull' && item.field!=='Quick Ship' &&item.field!=='Water Resistant'  && item.field !== 'MSRP' && item.field !== 'Price'">
            <ion-col>
              <ion-row class="field-title">
                <ion-col>
                  <h3>{{item.field}}:</h3>
                </ion-col>
              </ion-row>
              <ion-row class="field-value">
                <ion-col (click)="FieldValueSelected(value,item)" size="auto" class="each-value" *ngFor="let value of sortArray(item)" [class.available-item]="checkItemAvailability(value)" [class.selected-field-value]="value.selected"
                         [class.not-available]="!checkItemAvailability(value)">
                  <span>{{value.value}}</span>
                </ion-col>
              </ion-row>
            </ion-col>
          </ion-row>
        </ng-container>

        <ion-row class="qty">
          <ion-col size="auto">
            <h3>QTY:</h3>
          </ion-col>
          <ion-col class="qty-btn-holder">
            <ion-button (click)="changeQty(-1)" class="qty-btn minus-qty">
              <img src="../../../assets/icon/minus.svg" alt="minus"/>
            </ion-button>
            <ion-item lines="false">
              <input
                class="qty-input"
                type="tel"
                placeholder="Phone Number"
                [(ngModel)]="quantityInput"
                [mask]="'00'">
            </ion-item>
            <ion-button (click)="changeQty(1)" class="qty-btn plus-qty">
              <img src="../../../assets/icon/plus.svg" alt="plus"/>
            </ion-button>
          </ion-col>
        </ion-row>
        <ion-row *ngIf="isLogin && selectedProductToShowDetail?.price">
          <ion-col>
            <div class="price-primary">
              <b class="price"><small>$</small>{{selectedProductToShowDetail?.price}}</b>
              <label class="msrp"><small style="margin-right: 7px;">MSRP:</small> <small>$</small>{{selectedProductToShowDetail?.msrp}}</label>
            </div>
          </ion-col>
        </ion-row>
        <ion-row class="add-to-cart-row">
          <ion-col>
            <div class="add-to-cart">
              <p ></p>
              <ion-button [disabled]="productArray?.length>1 || productArray?.length===0"
                          class="add-to-cart"
                          (click)="addToCart()">
                <ng-container *ngIf="productArray?.length===0 && !isLoading">
                  No Item Available
                </ng-container>
                <ng-container *ngIf="productArray?.length>1 && !isLoading">
                  Filter out your Item
                </ng-container>
                <ng-container *ngIf="productArray?.length===1 && !isLoading">
                  Add To Cart
                </ng-container>
                <ng-container *ngIf="isLoading">
                  <ion-spinner class="add-loading" name="crescent"></ion-spinner>
                </ng-container>
              </ion-button>
              <span (click)="clearSelection()" *ngIf="productArray?.length===0" class="reset-selection">Reset</span>
            </div>
          </ion-col>

        </ion-row>
        <ion-row class="product-table">
          <ion-col>
            <!--            product table-->
            <ion-row class="table-pd-title">
              <ng-container *ngFor="let item of productData?.data?.products[0].items">
                <ion-col [class.sku]="item.field === 'SKU'" *ngIf="item.field !== 'Water Resistant'  && item.field !== 'Quick Ship' && item.field !== 'Appliance Pull'">
                  <b>{{item.field}}</b>
                </ion-col>
              </ng-container>
            </ion-row>
            <ion-row class="table-pd-items" (click)="selectProductToShow(product)" *ngFor="let product of productData?.data?.products" [class.available]="checkProductAvailability(product)">
              <ng-container *ngFor="let item of product.items">
                <ion-col class="each-table-item" [class.sku]="item.field === 'SKU'" *ngIf="item.field !== 'Water Resistant'   && item.field !== 'Quick Ship' && item.field !== 'Appliance Pull'">
                  <span>{{item.item_value}}</span>
                </ion-col>
              </ng-container>
            </ion-row>

          </ion-col>
        </ion-row>
      </ion-col>
    </ion-row>
    <ion-row class="specifications">
      <ion-col>
        <h2>Specifications</h2>
      </ion-col>
    </ion-row>
    <ion-row class="specifications-list">
      <ion-col sizeXl="6" sizeMd="6" sizeSm="6" sizeXs="12" *ngFor="let item of selectedProductToShowDetail?.items">

        <div class="specifications-inner" *ngIf=" item.field !== 'MSRP' && item.field !== 'Price'">
          <div class="specifications-title"><b>{{item.field}}</b></div>
          <div class="specifications-value"><span>{{item.item_value}}</span></div>
        </div>
      </ion-col>
    </ion-row>
    <ng-container *ngIf="similarProducts?.data?.similar_catalog?.length>0">


      <ion-row class="specifications">
        <ion-col>
          <h2> Related Catalogs</h2>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col>
          <app-product-swiper [dataArray]="similarProducts?.data?.similar_catalog"></app-product-swiper>
        </ion-col>
      </ion-row>
    </ng-container>
    <ng-container *ngIf="similarProducts?.data?.similar_collection?.length>0">

      <ion-row class="specifications">
        <ion-col>
          <h2>Related Collections</h2>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col>
          <app-product-swiper [dataArray]="similarProducts?.data?.similar_collection"></app-product-swiper>
        </ion-col>
      </ion-row>
    </ng-container>
  </ion-grid>

  <app-footer></app-footer>
</ion-content>
